<template>
  <TitleChapterList
    v-if="title.attributes.type !== 'novel'"
    :title-entity
    v-model:translation-locale="translationLocale"
  />
  <TitleNovelChapterList
    v-else
    :title-entity
    v-model:translation-locale="translationLocale"
  />
</template>

<script setup lang="ts">
import { type AvailableLanguages, type TitleEntity } from "~/src/api";
import TitleChapterList from "~/components/title/TitleChapterList.vue";

const nuxtApp = useNuxtApp();
const route = useRoute();
const { locale, t: translate } = useI18n();

const { titleEntity: title } = defineProps<{
  titleEntity: TitleEntity;
}>();

const translationLocale = ref(
  localeMap(route.query.lang as AvailableLanguages) || locale.value,
);
</script>
